export const pagesToHideProgressBarOn = [
    '/checkout-complete'
]